/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.GET_MODULE_TRANSLATIONS:
            this.moduleTranslations = action.response;
            this.emit(Constants.GET_MODULE_TRANSLATIONS);
            break;
        case Constants.GET_COUNTRIES:
            this.countries = action.response;
            this.emit(Constants.GET_COUNTRIES);
            break;
        case Constants.ON_TRANSLATION_UPDATE:

            this.translations = action.response;
            this.emit(Constants.ON_TRANSLATION_UPDATE);
            break;
    }

};

class Translation extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.translations = {};
    }

    getCountriesList(){
        return {
            'AFGHANISTAN' : 'Afghanistan',
            'ALBANIA' : 'Albania',
            'ALGERIA' : 'Algeria',
            'ANGOLA' : 'Angola',
            'ANTIGUA AND BARBUDA' : 'Antigua and Barbuda',
            'ARGENTINA' : 'Argentina',
            'ARMENIA' : 'Armenia',
            'ARUBA' : 'Aruba',
            'AUSTRALIA' : 'Australia',
            'AUSTRIA' : 'Austria',
            'AZERBAIJAN' : 'Azerbaijan',
            'BAHAMAS' : 'Bahamas',
            'BAHRAIN' : 'Bahrain',
            'BANGLADESH' : 'Bangladesh',
            'BARBADOS' : 'Barbados',
            'BELARUS' : 'Belarus',
            'BELGIUM' : 'Belgium - Flanders',
            'BELGIUMF' : 'Belgium - French',
            'BELIZE' : 'Belize',
            'BENIN' : 'Benin',
            'BERMUDA' : 'Bermuda',
            'BHUTAN' : 'Bhutan',
            'BOLIVIA' : 'Bolivia',
            'BOSNIA AND HERZEGOVINA' : 'Bosnia and Herzegovina',
            'BOTSWANA' : 'Botswana',
            'BRAZIL' : 'Brazil',
            'BRITISH_VIRGIN_ISLANDS' : 'British Virgin Islands',
            'BRUNEI' : 'Brunei',
            'BULGARIA' : 'Bulgaria',
            'BURKINA FASO' : 'Burkina Faso',
            'CAMBODIA' : 'Cambodia',
            'CAMEROON' : 'Cameroon',
            'CANADA' : 'Canada',
            'CAPE VERDE' : 'Cape Verde',
            'CAYMAN ISLANDS' : 'Cayman Islands',
            'CHILE' : 'Chile',
            'CHINA' : 'China',
            'COLOMBIA' : 'Colombia',
            'CONGO' : 'Congo',
            'CORAL SEA ISLANDS' : 'Coral Sea Islands',
            'COSTA RICA' : 'Costa Rica',
            'CROATIA' : 'Croatia',
            'CUBA' : 'Cuba',
            'CURACAO' : 'Curacao',
            'CYPRUS' : 'Cyprus',
            'CZECH REPUBLIC' : 'Czech Republic',
            'DENMARK' : 'Denmark',
            'DOMINICAN REPUBLIC' : 'Dominican Republic',
            'ECUADOR' : 'Ecuador',
            'EGYPT' : 'Egypt',
            'EL SALVADOR' : 'El Salvador',
            'ENGLAND' : 'England',
            'EQUATORIAL GUINEA' : 'Equatorial Guinea',
            'ESTONIA' : 'Estonia',
            'ETHIOPIA' : 'Ethiopia',
            'eSwatini' : 'eSwatini',
            'FAROE ISLANDS' : 'Faroe Islands',
            'FINLAND' : 'Finland',
            'FIJI' : 'Fiji',
            'FRANCE' : 'France',
            'FRENCH GUIANA' : 'French Guiana',
            'FRENCH POLYNESIA' : 'French Polynesia',
            'GABON' : 'Gabon',
            'GAMBIA' : 'Gambia',
            'GEORGIA' : 'Georgia',
            'GERMANY' : 'Germany',
            'GHANA' : 'Ghana',
            'GIBRALTAR' : 'Gibraltar',
            'GREECE' : 'Greece',
            'GREENLAND' : 'Greenland',
            'GRENADA' : 'Grenada',
            'GUAM' : 'Guam',
            'GUATEMALA' : 'Guatemala',
            'GUERNSEY' : 'Guernsey',
            'GUINEA' : 'Guinea',
            'GUYANA' : 'Guyana',
            'HAITI' : 'Haiti',
            'HONDURAS' : 'Honduras',
            'HONG KONG' : 'Hong Kong',
            'HUNGARY' : 'Hungary',
            'ICELAND' : 'Iceland',
            'INDIA' : 'India',
            'INDONESIA' : 'Indonesia',
            'IRAN' : 'Iran',
            'IRAQ' : 'Iraq',
            'IRELAND' : 'Ireland',
            'ISLE OF MAN' : 'Isle of Man',
            'ISRAEL' : 'Israel',
            'ITALY' : 'Italy',
            'IVORY COAST' : 'Ivory Coast',
            'JAMAICA' : 'Jamaica',
            'JAPAN' : 'Japan',
            'JERSEY' : 'Jersey',
            'JORDAN' : 'Jordan',
            'JORDON' : 'Jordon',
            'KAZAKHSTAN' : 'Kazakhstan',
            'KENYA' : 'Kenya',
            'KOREA' : 'Korea',
            'KOREA NORTH' : 'Korea North',
            'KOSOVO' : 'Kosovo',
            'KURDISTAN' : 'Kurdistan',
            'KUWAIT' : 'Kuwait',
            'KYRGYZSTAN' : 'Kyrgyzstan',
            'LAOS' : 'Laos',
            'LATVIA' : 'Latvia',
            'LEBANON' : 'Lebanon',
            'LESOTHO' : 'Lesotho',
            'LIBYA' : 'Libya',
            'LIBERIA' : 'Liberia',
            'LICHTENSTEIN' : 'Lichtenstein',
            'LITHUANIA' : 'Lithuania',
            'LUXEMBOURG' : 'Luxembourg',
            'MACAU' : 'Macau',
            'MACEDONIA' : 'Macedonia',
            'MADAGASCAR' : 'Madagascar',
            'MALAWI' : 'Malawi',
            'MALAYSIA' : 'Malaysia',
            'MALDIVES' : 'Maldives',
            'MALI' : 'Mali',
            'MALTA' : 'Malta',
            'MARIANA_ISLANDS' : 'Mariana Islands',
            'MARTINIQUE' : 'Martinique',
            'MAURITIUS' : 'Mauritius',
            'MAURITANIA' : 'Mauritania',
            'MAYOTTE' : 'Mayotte',
            'MEXICO' : 'Mexico',
            'MOLDOVA' : 'Moldova',
            'MONACO' : 'Monaco',
            'MONGOLIA' : 'Mongolia',
            'MONTENEGRO' : 'Montenegro',
            'MOROCCO' : 'Morocco',
            'MOZAMBIQUE' : 'Mozambique',
            'MYANMAR' : 'Myanmar',
            'NAMIBIA' : 'Namibia',
            'NEPAL' : 'Nepal',
            'NETHERLANDS' : 'Netherlands',
            'NEW CALEDONIA' : 'New Caledonia',
            'NEW ZEALAND' : 'New Zealand',
            'NICARAGUA' : 'Nicaragua',
            'NIGERIA' : 'Nigeria',
            'NORTHERN IRELAND' : 'Northern Ireland',
            'NORWAY' : 'Norway',
            'OMAN' : 'Oman',
            'PAKISTAN' : 'Pakistan',
            'PALESTINE' : 'Palestine',
            'PALESTINIAN' : 'Palestinian',
            'PANAMA' : 'Panama',
            'PAPUA NEW GUINEA' : 'Papua New Guinea',
            'PARAGUAY' : 'Paraguay',
            'PERU' : 'Peru',
            'PHILIPPINES' : 'Philippines',
            'POLAND' : 'Poland',
            'PORTUGAL' : 'Portugal',
            'PUERTO RICO' : 'Puerto Rico',
            'QATAR' : 'Qatar',
            'REUNION' : 'Reunion',
            'ROMANIA' : 'Romania',
            'RUSSIA' : 'Russia',
            'RWANDA' : 'Rwanda',
            'SAINT BARTHELEMY' : 'Saint Barthelemy',
            'SAINT KITTS AND NEVIS' : 'Saint Kitts and Nevis',
            'SAINT LUCIA' : 'Saint Lucia',
            'SAINT PIERRE AND MIQUELON' : 'Saint Pierre and Miquelon',
            'SAINT VINCENT AND THE GRENADINES' : 'Saint Vincent and the Grenadines',
            'SAN MARINO' : 'San Marino',
            'SAUDI ARABIA' : 'Saudi Arabia',
            'SCOTLAND' : 'Scotland',
            'SENEGAL' : 'Senegal',
            'SERBIA' : 'Serbia',
            'SEYCHELLES' : 'Seychelles',
            'SINGAPORE' : 'Singapore',
            'MAARTEN' : 'Sint Maarten',
            'MARSHALL' : 'Marshall',
            'SLOVAKIA' : 'Slovakia',
            'SLOVENIA' : 'Slovenia',
            'SOMALIA' : 'Somalia',
            'SOLOMON' : 'Solomon Islands',
            'SOUTH AFRICA' : 'South Africa',
            'SPAIN' : 'Spain',
            'SRI LANKA' : 'Sri Lanka',
            'HELENA' : 'St. Helena',
            'SUDAN' : 'Sudan',
            'Suriname' : 'Suriname',
            'SWAZILAND' : 'Swaziland',
            'SWEDEN' : 'Sweden',
            'SWITZERLAND' : 'Switzerland',
            'SYRIA' : 'Syria',
            'TAIWAN' : 'Taiwan',
            'TAJIKISTAN' : 'Tajikistan',
            'TANZANIA' : 'Tanzania',
            'THAILAND' : 'Thailand',
            'TIMOR' : 'Timor',
            'TONGA' : 'Tonga',
            'TRINIDAD AND TOBAGO' : 'Trinidad and Tobago',
            'TUNISIA' : 'Tunisia',
            'TURKEY' : 'Turkey',
            'TURKS' : 'Turks and Caicos',
            'TURKMENISTAN' : 'Turkmenistan',
            'U.S. VIRGIN ISLANDS' : 'U.S. Virgin Islands',
            'UAE' : 'UAE',
            'UGANDA' : 'Uganda',
            'UKRAINE' : 'Ukraine',
            'UNITED STATES' : 'United States',
            'URUGUAY' : 'Uruguay',
            'UZBEKISTAN' : 'Uzbekistan',
            'VANUATU' : 'Vanuatu',
            'VENEZUELA' : 'Venezuela',
            'VIETNAM' : 'Vietnam',
            'WALES' : 'Wales',
            'WESTERN SAHARA' : 'Western Sahara',
            'YEMEN' : 'Yemen',
            'ZAMBIA' : 'Zambia',
            'ZIMBABWE' : 'Zimbabwe',
        }
    }

    get(translationCode , plain) {
        if(!this.translations) return plain;
        if(!this.translations[translationCode])
        {
            console.log(translationCode +","+plain)
            return plain;
        }
        return this.translations[translationCode] || plain;
    }

    getModule(translationCode , plain) {
        if(!this.moduleTranslations) return plain;
        if(!this.moduleTranslations[translationCode]) return plain;

        return this.moduleTranslations[translationCode] || plain;
    }

    getModuleNoIndexTranslation(translationCode) {
        if(!this.moduleTranslations) return translationCode;
        if(!this.moduleTranslations[translationCode]) return translationCode;

        return this.moduleTranslations[translationCode] || 'ERROR NO TRANSLATION !!!!';
    }



}

export default new Translation();